import styled from "styled-components";

export const ButtonGroupWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ButtonGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
`;

export const DeleteIconWrapper = styled.div`
  padding: 8px;
  width: 48px;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 50%;

  &:hover {
    background-color: rgba(26, 28, 25, 0.12);
  }
`;
